import React from 'react';
import useUtilizationPerYearAverageChart from './hooks/useUtilizationPerYearAverageChart';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';

export const UtilizationPerYearAverage = ({ height }) => {
    const { series, subtitles } = useUtilizationPerYearAverageChart();

    return (
        <SimpleBars
            height={height}
            decimals={0}
            series={series}
            values={[]}
            subtitles={subtitles}
            title={`Média da Utilização Mensal por Ano`}
        />
    );
};
